/**
 * Therappi® Build/Deploy Stamp
 * Provides build metadata for debugging and deploy verification.
 */

export const BUILD_DATE = '2026-02-16';
export const APP_VERSION = '1.0.9';
export const GIT_SHA = 'unknown'; // Populated by CI if available

export function getBuildStamp(route?: string): string {
  const parts = [
    `Build: ${BUILD_DATE}`,
    `v${APP_VERSION}`,
    `SHA: ${GIT_SHA.substring(0, 7)}`,
  ];
  if (route) parts.push(`Route: ${route}`);
  return parts.join(' | ');
}
